export default "__VITE_ASSET__97f39c6a__"